<template>
  <div class="documents">
    <div class="documents__title">Документы</div>
    <ul>
      <li
        v-for="(item, index) in documents"
        :key="index"
        class="documents__item">
        <img :src="setIcon(item.path)" alt="" title="" />
        <a
          :href="`${baseUrl}/documents/${item.uuid}/show`"
          target="_blank">
          {{ item.name }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'Documents',

  metaInfo () {
    return {
      title: `Документы - Личный кабинет дилера - ${this.getDealerName}`,
    }
  },

  computed: {
    ...mapState({
      documents: state => state.account.documents.documents,
    }),

    ...mapGetters('user', [
      'getDealerName',
    ]),
  },

  methods: {
    ...mapActions('account/documents', [
      'loadDocuments',
    ]),

    setIcon(str) {
      const path = str.substr(str.lastIndexOf(".") + 1);
      return `/img/${path.toLowerCase()}.png`;
    },
  },

  created() {
    this.loadDocuments();
  }
}
</script>

<style lang="scss" scoped>
.documents {
  &__title {
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    position: fixed;
    z-index: 120;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 53px;
    margin: 0;

    @media(max-width: $desktop) {
      position: static;
      height: auto;
      transform: translateX(0);
      margin-bottom: 11px;
    }
  }

  ul {
    font-size: 0;
    width: 100%;
  }

  &__item {
    padding: 10px 40px;
    max-width: 500px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: flex-start;

    img {
      width: 18px;
      height: auto;
      flex-shrink: 0;
      margin-right: 5px;
    }

    &:nth-child(even) {
      background-color: #F3F3F3;
    }

    a {
      display: inline-block;
      text-decoration: underline;
      color: #4b9dbd;
      font-size: 14px;
      line-height: 16px;
    }
  }
}
</style>
